module.exports = __webpack_public_path__ + "static/media/agriminer-signin.dc6ae70b.jpg";